import { Component, OnInit, ViewChild, HostListener, } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { TermsCondtionsComponent } from 'src/app/components/auth/terms-condtions/terms-condtions.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { WebsocketService } from 'src/app/core/services/websocket.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  currentuser: any;
  sidebarSubscription: Subscription;
  userData: any;

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   var x = window.innerWidth;
  //   console.log(x)
  //   if (window.innerWidth < 1199) {
  //     this.openSidebar();
  //   }
  // }
  constructor(
    public _authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService,
    private webSocketService: WebsocketService
  ) {
    this.sidebarSubscription = this._authService.loadSidebar().subscribe(
      (item) => {
        this.ngOnInit();
      });
  }

  ngOnInit() {
    this.currentuser = this._authService.getCurrentUser();

    if (window.localStorage.getItem('IsSideNavOpen') == null) {
      window.localStorage.setItem('IsSideNavOpen', 'true');
    }
    if (window.localStorage.getItem('IsSideNavOpen') == 'true') {
      document.body.classList.add("toggle-nav");
      document.body.classList.remove("show-menu");
    }
  }

  showTerms() {
    this.modalService.open(TermsCondtionsComponent, {
      windowClass: 'center',
      keyboard: false,
      centered: true,
      backdrop: 'static',
      size: "lg"
    });
  }

  logOut() {

    let uploadingProcess = this._localStorageService.getItem('uploadingProcess');

    if (uploadingProcess != true) {
      this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
        this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
      this.spinner.show();
      this._authService.logOut().subscribe(
        (response: any) => {
          this.spinner.hide();
          if (this.userData) {
            this.webSocketService.offlineSocket(this.userData['chat_sku']);
          }
          this._authService.cancelUploadingFileDetect(true);
          this._authService.clearStorage();
          this.router.navigate(['/']);
        }, (error: any) => {
          this.spinner.hide();
        });
    }
    else {
      var userselection = confirm("The changes you made may not be saved. Are you sure you want to logout?");

      if (userselection == true) {
        this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
          this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
        this.spinner.show();
        this._authService.logOut().subscribe(
          (response: any) => {
            this.spinner.hide();
            if (this.userData) {
              this.webSocketService.offlineSocket(this.userData['chat_sku']);
            }
            this._authService.cancelUploadingFileDetect(true);
            this._authService.clearStorage();
            this.router.navigate(['/']);
          }, (error: any) => {
            this.spinner.hide();
          });
      }
    }
  }

  openSidebar() {
    if (document.body.classList.contains('toggle-nav')) {
      document.body.classList.remove("toggle-nav");
      window.localStorage.setItem('IsSideNavOpen', 'false');
    } else {
      document.body.classList.add("toggle-nav");
      window.localStorage.setItem('IsSideNavOpen', 'true');
    }
  }

  isLinkActive(url): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl = queryParamsIndex === -1 ? this.router.url :
      this.router.url.slice(0, queryParamsIndex);
    return baseUrl === url;
  }
}
